'use client';

import { c as _c } from "react/compiler-runtime";
import { P2 } from '@algoacademy/design-system/web/typography/Paragraph/P2';
import { IconOnTheLeftWithContentLayout } from '@/app/(marketing-site)/mentoring/_layouts/IconOnTheLeftWithContentLayout';
import { benefitsForIncludedPlanModal, IncludedPlanBenefitItem } from '../../_components/IncludedPlanBenefitsDialog';
import { BENEFITS as BASIC_PLAN_BENEFITS } from '../GroupMentoring/Options';
import { INDIVIDUAL_PLAN_BENEFITS } from '../IndividualMentoring/IndividualPlanBenefits';
type BenefitItem = {
  lead: string;
  rest: string;
};
export const PROJECT_BENEFITS: BenefitItem[] = [{
  lead: 'Wszystko z planu mentoringu rozszerzonego',
  rest: 'Dostajesz pełen pakiet mentoringu rozszerzonego, więc nic nie tracisz.'
}, {
  lead: 'Mentor tylko dla Ciebie',
  rest: 'Projektowo mentor prowadzi tylko jedną osobę naraz, dzięki czemu cały swój czas i uwagę poświęca tylko Tobie'
}, {
  lead: 'Regularne spotkania 1:1 z mentorem',
  rest: 'Co 4 tygodnie masz zagwarantowane regularne spotkania 1:1 z mentorem w wymiarze min. 10 godzin'
}, {
  lead: 'Nauka na prawdziwym projekcie',
  rest: 'Uczysz się przez działanie. Twoje decyzje mają realne konsekwencje, a efekty pracy trafiają wprost do działającego produktu'
}, {
  lead: 'Mentor angażuje się w projekt',
  rest: 'Razem planujecie, omawiacie i wdrażacie konkretne funkcje. Nauka idzie w parze z realnym postępem, nie tylko z rozmowami o kodzie'
}, {
  lead: 'Nie tylko kod',
  rest: 'Rozmawiacie też o tym, jak produkt rozwijać, jak go sprzedawać i jak zatrzymać użytkowników - bo dobry kod to nie wszystko'
}, {
  lead: 'Narzędzia AI w cenie',
  rest: 'Dostajesz licencje i kredyty do płatnych narzędzi AI o wartości do 2 000 zł miesięcznie, gotowe do użytku od pierwszego dnia'
}, {
  lead: 'Kontakt ze środowiskiem inwestycyjnym',
  rest: 'Możesz pokazać swój projekt inwestorom i zebrać konkretny feedback, zarówno przed premierą, jak i w jej trakcie'
}];
const [includedExtendedPlan, ...projectOnlyBenefits] = PROJECT_BENEFITS;
const [, ...extendedOnlyBenefits] = INDIVIDUAL_PLAN_BENEFITS;
export function ProjectMentoringOptions() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ul className="space-y-4"><li key={includedExtendedPlan.lead}><IncludedPlanBenefitItem lead={includedExtendedPlan.lead} rest={includedExtendedPlan.rest} dialogTitle="Mentoring rozszerzony zawiera" sections={[{
          benefits: benefitsForIncludedPlanModal([...BASIC_PLAN_BENEFITS, ...extendedOnlyBenefits], {
            forProjectPlan: true
          })
        }]} /></li>{projectOnlyBenefits.map(_temp)}</ul>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(t0) {
  const {
    lead,
    rest
  } = t0;
  return <li key={lead}><IconOnTheLeftWithContentLayout mainContent={<P2 className="text-contentSecondary"><strong className="block font-semibold text-contentPrimary">{lead}</strong>{rest}</P2>} /></li>;
}